import { useSelector } from 'react-redux'
import { SCREEN } from '../../../../../common/selectCurrencyUnit/constant'
import { useFormatCurrency } from '../../../../../common/selectCurrencyUnit/useFormatCurrency'
import { formatVal } from '../../../../../helpers/value'

export const ValueCell = ({ val }) => {
  const { formatCurrency } = useFormatCurrency(SCREEN.PEER_ANALYSIS)

  const locale = useSelector((state) => state.i18n.locale)

  return (
    <div>
      {val.unit === '%'
        ? formatVal(val.value * 100, locale)
        : val.unit === 'VND'
        ? formatCurrency({
            value: val.value,
            year: val.realYear,
            exchangeRateType: 'lastDayRate',
          })
        : formatVal(val.value, locale)}
    </div>
  )
}
